import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.brand}>
          <span style={styles.logo}>Sytch</span>
          <span style={styles.tagline}>Safe, affordable ride sharing between real people.</span>
        </div>
        <div style={styles.links}>
          <Link to="/terms" style={styles.link}>Terms of Service</Link>
          <Link to="/privacy-policy" style={styles.link}>Privacy Policy</Link>
        </div>
        <div style={styles.copyright}>
          <p style={styles.copyrightText}>© 2026 Sytch LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    background: '#1a1a2e',
    color: '#b0bec5',
    marginTop: '60px',
    padding: '40px 20px',
    fontFamily: 'Arial, sans-serif',
  },
  container: {
    maxWidth: '1000px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px',
  },
  brand: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
  },
  logo: {
    color: '#4fc3f7',
    fontSize: '24px',
    fontWeight: 'bold',
  },
  tagline: {
    fontSize: '14px',
    color: '#b0bec5',
  },
  links: {
    display: 'flex',
    gap: '24px',
  },
  link: {
    color: '#b0bec5',
    textDecoration: 'none',
    fontSize: '14px',
  },
  copyright: {
    paddingTop: '20px',
    width: '100%',
    textAlign: 'center',
    borderTop: '1px solid #2a2a4e',
  },
  copyrightText: {
    fontSize: '12px',
    color: '#666',
    margin: 0,
  },
};

export default Footer;
